let attribution = null;

export const captureAttribution = () => {
  const p = new URLSearchParams(window.location.search);
  attribution = {
    utm_source: p.get("utm_source"),
    utm_medium: p.get("utm_medium"),
    utm_campaign: p.get("utm_campaign"),
    utm_content: p.get("utm_content"),
    utm_term: p.get("utm_term"),
    fbclid: p.get("fbclid"),
    gclid: p.get("gclid"),
    pageUrl: window.location.href,
    referrer: document.referrer || null,
    landedAt: new Date().toISOString(),
  };
};

export const getAttribution = () => attribution || {};
